import React, {useState} from "react";
import {Grid, Paper, Typography} from "@mui/material";
import {useLocation} from 'react-router';
import SignUpForm from "../components/SignUpForm";
import {styled} from "@mui/system";

const LoginLinkContainer = styled(Grid)(() => ({
  marginTop: '1.71rem',
  height: '4.29rem',
  backgroundColor: '#FAFAFA',
  borderRadius: '0 0 0.57rem 0.57rem',
  width: '100%',
}));

const SignUpContainer = styled(Paper)(() => ({
  display: 'flex',
  flexDirection: 'column',
  borderRadius: '0.57rem',
  overflow: 'hidden',
  width: '100%',
}));

const HubspotBuyerSignup = ({type}) => {

  const [formSubmitted, setFormSubmitted] = useState(false);
  const location = useLocation();

  // Extract UTM parameters from URL
  const searchParams = new URLSearchParams(location.search);
  const utmParams = {
    utm_source: searchParams.get('utm_source'),
    utm_medium: searchParams.get('utm_medium'),
    utm_campaign: searchParams.get('utm_campaign'),
    utm_term: searchParams.get('utm_term'),
    utm_content: searchParams.get('utm_content')
  };

  const nullFunc = () => {
  };
  const onSubmitForm = () => {
    setFormSubmitted(true)
  };

  return (
    <Grid container>
      {
        !formSubmitted ?
          <Grid item>
            <SignUpForm
              type={type}
              handleAccountChange={nullFunc}
              socialLoginTemporaryUser={nullFunc}
              externalForm={true}
              externalSubmitForm={onSubmitForm}
              utmParams={utmParams}
            />
          </Grid>
          :
          <LoginLinkContainer item container alignContent='center'>
            <SignUpContainer elevation={2}>
              <Typography variant="subtitle2" align='center' color="textPrimary" className='w-100'>
                Thank you for registering with SecurSpace!
                Please check your email for a welcome message, or click <a href="https://www.secur.space">here</a> to
                visit out home page.
              </Typography>
            </SignUpContainer>
          </LoginLinkContainer>
      }
    </Grid>
  )

}

export default HubspotBuyerSignup;
